<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="6">
          <!-- <v-card-title class="text-h5">Credit Note / ใบลดหนี้</v-card-title> -->
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6">
          <!-- <v-btn to="/so-for-invoice" color="#0A7EA5" rounded dark class="mb-2">
              <span>Add</span>
              <v-icon small center>add</v-icon>
            </v-btn> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="7">
              <v-text-field v-model="search" append-icon="mdi-magnify" :label="setlanguage.labelsearch" single-line
                hide-details outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <!-- <v-autocomplete
                  v-model="search"
                  :items="status"
                  label="Status"
                  outlined
                  dense
                ></v-autocomplete> -->
            </v-col>
            <v-col cols="12" md="1"> </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-end mb-6">
          <v-btn class="mr-2" @click="showsearchmore">
            {{ setlanguage.adddata }}
            <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="toggleEnable">
        <v-col cols="12" md="6"> </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddatefromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
        <!-- <v-col align="right" cols="12" xl="1" lg="1" md="1"></v-col>
          <v-col align="right" cols="12" xl="2" lg="2" md="2">
              <v-autocomplete
                v-model="search"
                :items="status"
                label="Status"
                outlined
                dense
              ></v-autocomplete>
            </v-col> -->
      </v-row>

      <br />

      <v-card outlined tile>
        <v-data-table dense :search="search" :headers="headers" :items="mDataArray" class="elevation-1   595959">
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn depressed class="mx-2" color="#C8E0FE" x-small @click="onClicktonewinvoice(item.id)">
              Credit Note
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <template>
        <div id="mydivhtmltobase">
          <!-- v-for="index in datashowAll.length"  v-if="datashowAll.length >= 0 || pageAll >= 0" -->
          <div v-for="index in datashowAll.length" v-if="datashowAll.length >= 0 || pageAll >= 0">
            <div class="aligncenter" id="foo">
              <page size="A4" class="aligncenter">
                <div class="aligncenter">
                  <div class="rowprpo ">
                    <div class="col-md-12report">
                      <h3 class="aligncenter  colprpo  mt30">
                        {{ dataformatpr.headtitle }}
                      </h3>
                    </div>
                  </div>
                  <div class="rowprpo mr30prpo mt-30prpo">
                    <div class="col-md-8report"></div>
                    <div class="col-md-4report">
                      <h4 class="alignleft  colprpo ">
                        Receive No : {{ index }}
                      </h4>
                    </div>
                  </div>
                  <div class="rowprpo aligncenter">
                    <div class="col-md-12report ">
                      <h3>
                        {{ dataformatpr.title }}
                      </h3>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.subtitle }}
                      </h5>
                    </div>
                  </div>
                  <br />
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h4>
                        {{ dataformatpr.titleth }}
                      </h4>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.address1 }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.address2 }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.address3 }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.address4 }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.tel }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.fax }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.email }}
                      </h5>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        {{ dataformatpr.taxid }}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="fontsize14">
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <v-divider></v-divider>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">To / ถึง Customer Name</p>
                      <p class="alignright">Date / วันที่ :______________</p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter mt-15prpo">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">Address 1</p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter mt-15prpo">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">Address 2</p>
                      <p class="alignright">
                        Invoice No. / ใบวางบิล :______________
                      </p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter mt-15prpo">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">City, Postcode</p>
                      <p class="alignright">
                        Payment / ชำระโดย :______________
                      </p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter mt-15prpo">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">COUNTRY</p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter mt-15prpo">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <p class="alignleft">
                        Tax ID / เลขที่ผู้เสียภาษี :______________
                      </p>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                  <div class="rowprpo  aligncenter ">
                    <div class="col-md-1report"></div>
                    <div class="col-md-10report">
                      <v-divider></v-divider>
                    </div>
                    <div class="col-md-1report"></div>
                  </div>
                </div>

                <div class="rowprpo caption  ml30prpo mr30prpo" style="margin-top:10px">
                  <table class="captionhtable ">
                    <tr>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width50">
                        <span class="aligncenter fontsize14">Description / รายการ
                        </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width25">
                        <span class="aligncenter fontsize14">Quantity / จำนวน
                        </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width25">
                        <span class="aligncenter fontsize14">Amount / จำนวนเงิน
                        </span>
                      </th>
                    </tr>
                    <!-- <tr>
                        <th scope="col" class="prborderbottom">No.</th>
                        <th scope="col" class="prborderbottom">Item Number</th>
                        <th scope="col" class="prborderbottom">Description</th>
                        <th scope="col" class="prborderbottom">Quality</th>
                        <th scope="col" class="prborderbottom">Unit</th>
                      </tr> -->

                    <!-- <tr
                        v-for="(data, i) in setdatatoshow[index - 1]"
                        id="content"
                        class=""
                      >
                        <td class="width10">
                          <span class="alignleft">{{ data.no }}</span>
                        </td>
                        <td class="width20" colspan="2">
                          <span class="alignleft"> {{ data.checkInDate }}</span>
                        </td>
                        style="white-space: pre-line"
                        <td class="width10">
                          <span class="alignleft">PM</span>
                        </td>
                        <td class="width10">
                          <span class="alignleft">{{ data.duration }}</span>
                        </td>
                        <td class="width50">
                          <span class="alignleft"> {{ data.detail }}</span>
                        </td>
                      </tr> -->
                  </table>
                </div>

                <div v-for="(data, i) in datashowAll[index - 1]" id="content" class="">
                  <div class="rowprpo ml30prpo mr30prpo " v-if="i == 0 && data.no == 1">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft ">
                        <span v-if="data.cust_account">
                          {{ data.cust_account }}</span>
                        <span v-else-if="data.user_id">
                          {{ data.user_id }}</span>
                        <span v-else> -</span>
                      </h4>
                    </div>
                    <div class="width90 fixonerow">
                      <h4 class="alignleft">
                        <span v-if="data.customer_name">
                          {{ data.customer_name }}</span>
                        <span v-else-if="data.fullname">
                          {{ data.fullname }}</span>
                        <span v-else> -</span>
                      </h4>
                    </div>
                  </div>
                  <!-- <div
                      class="rowprpo ml30prpo mr30prpo mt10 "
                      v-if="i == 0 && data.no == 1"
                    >
                      <div class="width10 fixonerow">
                        <h4 class="alignleft"></h4>
                      </div>
                      <div class="width90 fixonerow">
                        <h4 class="alignleft">
                          changedepartment
                          <span v-if="data.department_name"  >
                            {{ data.department_name }}</span
                          >
                          <span v-else> -</span>
                        </h4>
                      </div>
                    </div> -->
                  <div class="rowprpo ml30prpo mr30prpo mt10 " v-if="data.changedepartment">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft"></h4>
                    </div>
                    <div class="width90 fixonerow">
                      <h4 class="alignleft">
                        <span v-if="data.department_name">
                          {{ data.department_name }}</span>
                        <span v-else> </span>
                      </h4>
                    </div>
                  </div>

                  <div class="rowprpo ml30prpo mr30prpo captionreport">
                    <div class="width10 textalignleft">
                      <!-- {{ data.no }} -->
                    </div>
                    <div class="width20 textalignleft" colspan="2">
                      {{ data.checkInDate }}
                    </div>
                    <!-- style="white-space: pre-line" -->
                    <div class="width10 textalignleft">
                      <span v-if="data.abbname_e_n">{{
                        data.abbname_e_n
                      }}</span>
                      <span v-else>-</span>
                    </div>
                    <div class="width10 textalignleft">
                      {{ data.duration }}
                    </div>
                    <div class="width50 textalignleft">
                      {{ data.detail }}
                    </div>
                  </div>
                  <div class="rowprpo ml30prpo mr30prpo " v-if="data.lastdata == 'lastindex'">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft "></h4>
                    </div>
                    <div class="width30 fixonerow">
                      <h4 class="alignleft">
                        Total Client
                      </h4>
                    </div>
                    <div class="width60 fixonerow">
                      <h4 class="alignleft">
                        {{ data.totalclient }}
                      </h4>
                    </div>
                  </div>
                </div>
              </page>
            </div>
          </div>
        </div>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";

export default {
  name: "invoice",
  data(vm) {
    return {
      dataformatpr: {
        headtitle: "Receive",
        title: "Dej-Udom & Associates LTD.",
        subtitle: "ATTORNEY AT LAW",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
        titleth: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
        address1: "CHARN ISSARA TOWER 9 FLOOR",
        address2: "942/69 RAMA IV ROAD,",
        address3: "KWAENG SURIYAWONG, KHET BANGRAK,",
        address4: "BANGKOK 10500, THAILAND",
        tel: "Tel : 0-2233-0055, 0-2267-5152",
        fax: "Fax : 0.2236-6681, 0-2233-0227",
        email: "E-MAIL:account@dejudom.com",
        taxid: 'TAX ID. No. 0105534015348/"HEAD OFFICE"',
      },
      datashowAll: [],
      setdatatoshow: [],
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "P.Invoice", "Invoice", "Cancel"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [
        {
          id: "97",
          date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
          customer: "testcus",
          status: "Draft",
        },
      ],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "Invoice No.",
          value: "invoice_no",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Client",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
        },

        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
        },
      ],
    };
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.headers = language.en.headertable;
    // this.initialize();
  },
  beforeUpdate() { },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await this.loaddataInvoice();
  },
  methods: {
    editItem() { },

    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    finddatafromdate() {
      //alert(this.datefrom)
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.datefrom != null && this.dateto != null) {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        }
        if (this.datefrom == null && this.dateto == null) {
          return item;
        }
      });
    },
    onClicktonewinvoice(id) {
      let name = "inv_h";
      this.$router.push(`/add-credit-note/${id}`);
    },
    async loaddataInvoice() {
      const result = await api.billing_expense_getcreditnoteBycompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.dataAll = result.data;
      console.log(this.dataAll);
      //   console.log("loadLeave", JSON.stringify(this.dataAll));
      this.mDataArray = result.data;
      this.mDataArray.forEach((item) => {
        if (item.inv_id) {
          item.invoice_no = item.inv_id;
        } else if (item.pinv_id) {
          item.invoice_no = item.pinv_id;
        } else {
          item.invoice_no = "####";
        }
      });

      // this.$showLoader();
      this.$hideLoader();
    },
    async checkcontent(data) {
      let totalclient = 0;
      console.log("send data ====");
      console.log(this.dataforshowprpo[0]);
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 34;
      let datainlineprpo = 45;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.dataforshowprpo[0].length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.dataforshowprpo[0][i].detail.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.dataforshowprpo[0][i].no = i + 1;
        totalclient += parseFloat(
          this.dataforshowprpo[0][i].duration
            ? this.dataforshowprpo[0][i].duration
            : 0
        );
        if (i == 0) {
          this.checkdepartmentname = this.dataforshowprpo[0][i].department_name;
          this.dataforshowprpo[0][i].changedepartment = true;
        } else {
          if (
            this.checkdepartmentname !==
            this.dataforshowprpo[0][i].department_name
          ) {
            this.dataforshowprpo[0][i].changedepartment = true;
            this.checkdepartmentname = this.dataforshowprpo[0][
              i
            ].department_name;
            hllinedetails++;
          }
        }
        stringchecklength = this.dataforshowprpo[0][i].detail;

        // let myArrayname = this.dataforshowprpo[i].NAME.split("\n");
        // for (let a = 0; a < myArrayname.length; a++) {
        //   let lengthnewline = myArrayname[a].length;
        //   for (let b = 0; b < myArrayname[a].length; b++) {
        //     if (
        //       myArrayname[a][b] == maiek ||
        //       myArrayname[a][b] == maito ||
        //       myArrayname[a][b] == maitree ||
        //       myArrayname[a][b] == maijattawa ||
        //       myArrayname[a][b] == vowelei ||
        //       myArrayname[a][b] == vowelee ||
        //       myArrayname[a][b] == voweleue ||
        //       myArrayname[a][b] == voweleu ||
        //       myArrayname[a][b] == vowelu ||
        //       myArrayname[a][b] == voweluu ||
        //       myArrayname[a][b] == maihun ||
        //       myArrayname[a][b] == maiyamok
        //     ) {
        //       lengthnewline--;
        //     }

        //   }

        for (let j = 0; j < this.dataforshowprpo[0][i].detail.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.dataforshowprpo[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.dataforshowprpo[0][i]);
        // console.log(getdata.length);
        // console.log(hllinedetails + newhllinedetails + getdata.length);
        // console.log(hllinedetails);
        // console.log(newhllinedetails);
        // console.log(getdata.length);
        // console.log("=================================");
        if (hllinedetails + newhllinedetails > linedetailprpo) {
          console.log(i + " ============== " + this.dataforshowprpo[0].length);
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.dataforshowprpo[0][i]);
          hllinedetails += newhllinedetails;
          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.dataforshowprpo[0][i]);

          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;
      console.log(this.pageAll);
      console.log("showwwwwwwwwwwwwwwwwwwww");
      console.log(this.setdatatoshow);

      this.setdatatoshow.forEach((item, iitem) => {
        console.log(item);
        console.log(iitem + " " + this.setdatatoshow[0].length);
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
      console.log(this.datashowAll);
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}

.text-left {
  color: aliceblue;
}

.widthsizesearch {
  width: 70%;
}

.theme--light.v-card {
  border-color: white;
}

body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-15prpo {
  margin-top: -15px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 1px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

th {
  border: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
            body.A3.landscape { width: 420mm }
            body.A3, body.A4.landscape { width: 297mm }
            body.A4, body.A5.landscape { width: 210mm }
            body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize14 {
  font-size: 14px;
}
</style>
